<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >
    <div><span class="address" :class="context.model=='yes' ? 'strike' : ''">{{ getAnswer('confirm','initial_full_address') }}</span>
      <a v-if="context.model == 'no'" v-on:click="context.model = 'yes'">Edit</a>
      <a v-if="context.model == 'yes'" v-on:click="context.model = 'no'">Cancel</a></div>
    <FormulateInput
        style="display:none"
        type="radio"
        :name="context.name"
        v-model="context.model"
        :options="context.options"
        @blur="context.blurHandler" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
        
    }
  },
  beforeMount () {
    // set to store for quote to work

    // set value directly on input so reactive stuff works
    //this.context.model = this.getInputValue;
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', getAnswer: 'getAnswer' }),
    model () {
      return this.context.model
    },
  }
}
</script>

<style scoped lang="scss">
  .formulate-input-label--after {
    display: none;
  }

  .address {
    padding-right:1rem;
  }

  .strike {
    text-decoration: line-through;
  }
</style>